var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import Notification from "../components/Notification";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import useSessionStorage from "../hooks/useLocalStorage";
import { unauthenticatedUser } from "../contexts/AuthProvider";
import useAuth from "../hooks/useAuth";
import cookies from "../services/cookies";
import { getAuthenticatedUserData } from "../services/auth";
function Loading() {
    var magicAuthenticate = useAuth().magicAuthenticate;
    var navigate = useNavigate();
    var _a = useSessionStorage('user', unauthenticatedUser), auth = _a[0], setAuth = _a[1];
    useEffect(function () {
        var queryParams = new URLSearchParams(window.location.search);
        var data = queryParams.get('token');
        var jwt = data === null || data === void 0 ? void 0 : data.substring(0, data === null || data === void 0 ? void 0 : data.indexOf(':'));
        var loginToken = data === null || data === void 0 ? void 0 : data.substring((data === null || data === void 0 ? void 0 : data.indexOf(':')) + 1);
        if (jwt == undefined) {
            navigate('/login');
        }
        else if (jwt === cookies.get('token')) {
            handleLoggedData().then(function () {
                window.location.reload();
            });
        }
        else if (jwt != undefined && loginToken != undefined) {
            handleAuth(jwt, loginToken);
        }
    }, []);
    function handleAuth(jwt, loginToken) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        Notification().Loading.circle("Redirecionando");
                        return [4 /*yield*/, magicAuthenticate(jwt, loginToken).then(function (res) {
                                Notification().Loading.remove();
                            }, function (err) {
                                console.log('erro ao conectar, contate o administrador');
                            })];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    }
    function handleLoggedData() {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, getAuthenticatedUserData().then(function (res) {
                            setAuth({
                                signed: true,
                                id: res.data.user.id,
                                name: res.data.user.name,
                                role_id: res.data.user.role_id,
                                permissions: res.data.permissions,
                                impersonate: false,
                                has_unpaid_bills: res.data.customer.length !== 0 ? res.data.customer.has_unpaid_bills : 0
                            });
                        })];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    }
    return null;
}
export default Loading;
